<template>
  <div class="right-cont">
    <div class="page-name">个人资料</div>
    <div class="user-label">头像</div>
    <div class="upload-nick">
      <img :src="form.head_pic ? form.head_pic: ''" alt="">
      <div class="upload-nick-cover" @click="openEditHeadImg">编辑</div>
    </div>
    <div class="d-flex">
      <div class="person-input-item">
        <div class="user-label">姓名</div>
        <input v-model="form.real_name" class="small-input user-input" type="text">
      </div>
      <div class="person-input-item">
        <div class="user-label">身份</div>
        <div class="small-input user-input dis-input" style="font-size: 14px;line-height: 34px">{{ memberTypeDict[form.member_type] ? (memberTypeDict[form.member_type] == '业务员' && member.is_salesman_manager ? '业务经理': memberTypeDict[form.member_type]) : '' }}</div>
      </div>
    </div>
    <div class="user-label">简介</div>
    <textarea v-model="form.introduction" class="person-textarea"></textarea>
    <div v-if="member.member_type == 0" class="d-flex">
      <div class="person-input-item">
        <div class="user-label">机构</div>
        <input v-model="form.organization" class="small-input user-input" type="text">
      </div>
      <div class="person-input-item">
        <div class="user-label">机构所在地</div>
        <!-- <input type="text" class="small-input user-input"> -->
        <el-cascader v-model="receiverArea" :options="areaData" @change="handleAreaChange"></el-cascader>
      </div>
    </div>
    <div v-if="member.member_type == 0" class="user-label">详细地址（选填）</div>
    <input v-if="member.member_type == 0" v-model="form.detail_address" class="user-input" type="text">
    <div class="take-dialog-bottom">
      <!-- <div class="take-dialog-close">取消</div> -->
      <div class="take-dialog-open" @click="submitForm">保存</div>
    </div>
    <el-dialog :visible.sync="showEditNickDialog" custom-class="take-dialog pad-btm-80" title="编辑头像" width="540px">
      <div class="d-flex-between">
        <div class="edit-nick-left">
          <div v-if="previewHeadImg" class="edit-nick-left-img">
            <img :src="previewHeadImg">
            <img src="@/assets/img/user_center/cover.png">
          </div>
          <template v-else>
            <div class="edit-nick-left-upload">
              <img alt="" src="@/assets/img/user_center/upload-icon.png">
              <div class="edit-nick-left-info">点击上传头像</div>
            </div>
            <input class="edit-nick-left-upload-input" accept="image/*"  :multiple="false" type="file" @change="handleFileChange">
            <div class="edit-nick-left-info">支持jpg、png格式的图片，大小不超过3M</div>
          </template>
        </div>
        <div class="edit-nick-right">
          <img :src="previewHeadImg ? previewHeadImg : ''">
          <div>头像预览</div>
        </div>
      </div>
      <div class="take-dialog-bottom edit-nick-btn">
        <template v-if="form.head_pic">
          <div class="take-dialog-close edit-nick-reload-upload">重新上传</div>
          <input class="edit-nick-reload-upload-input" accept="image/*"  :multiple="false" type="file" @change="handleFileChange">
        </template>
        <template v-else>
          <div class="take-dialog-close edit-nick-reload-upload disClick">重新上传</div>
        </template>
        <div class="take-dialog-close" @click="showEditNickDialog = false">取消</div>
        <div class="take-dialog-open" @click="submitEditHead">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {updateInfo, user_info} from "@/http/user_center";
import {GetArea} from "@/http/api";
import ossUpload from "@/http/ossUpload";

export default {
  name: "personal_data",
  data() {
    return {
      showEditNickDialog: false,
      form: {
        id: undefined,
        head_pic: undefined,
        real_name: undefined,
      },
      member: {},
      memberTypeDict: {
        0: "医生",
        1: "导师",
        2: "业务员",
        3: "客服",
        4: "技师",
        5: "供应商",
      },
      areaData: [],
      receiverArea: [],
      header_pic_preview: "",
      formLoading: false,
      previewHeadImg:''
    };
  },
  created() {
    this.getArea();
    this.getData();
  },
  methods: {
    getData() {
      user_info().then((res) => {
        this.member = res.data;
        this.$store.commit('memberChange',res.data)
        localStorage.setItem('member',JSON.stringify(res.data))
        this.form = {
          head_pic: this.member.head_pic,
          real_name: this.member.real_name,
          member_type: this.member.member_type,
          introduction: this.member.introduction,
          organization: this.member.organization,
          province: this.member.province,
          city: this.member.city,
          district: this.member.district,
          detail_address: this.member.detail_address,
        };
        this.previewHeadImg = this.member.head_pic
        this.receiverArea = [];
        if (this.member.province) {
          this.receiverArea.push(this.member.province);
        }
        if (this.member.city) {
          this.receiverArea.push(this.member.city);
        }
      });
    },
    getArea() {
      GetArea({level: 2}).then((res) => {
        this.areaData = res.data;
      });
    },
    handleAreaChange(val) {
      this.receiverArea = val;
      this.form.province = val[0];
      this.form.city = val[1];
    },
    submitForm() {
      if (!this.form.head_pic) {
        return this.$message.error("请上传头像");
      }
      if (!this.form.real_name) {
        return this.$message.error("请输入姓名");
      }
      if (!this.form.introduction) {
        return this.$message.error("请输入简介");
      }
      if (this.member.member_type == 0 && !this.form.organization) {
        return this.$message.error("请输入机构");
      }
      if (this.member.member_type == 0 && (!this.form.province || !this.form.city)) {
        return this.$message.error("请选择机构所在地");
      }
      if (this.formLoading) {
        return;
      }
      this.formLoading = true;
      updateInfo(this.form)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功",
            });
          } else {
            this.$message.error(res.message[0] ? res.message[0] : "修改失败");
          }
          this.formLoading = false;
          this.getData();
        })
        .catch(() => {
          this.formLoading = false;
          this.getData();
        });
    },
    handleFileChange(e){
      ossUpload.bucketUpload(
        e.target.files[0],
        (res) => {
          this.previewHeadImg = res.url;
        },
        (err) => {
          this.$message({
            type: "error",
            message: "上传失败",
          });
        },"duole-images","/upload/image/pc/nick/"
      );
    },
    openEditHeadImg(){
      this.showEditNickDialog = true
      this.previewHeadImg = this.form.head_pic
    },
    submitEditHead(){
      this.showEditNickDialog = false
      this.form.head_pic = this.previewHeadImg
      this.submitForm()
    }
  },
};
</script>

<style scoped src="../../assets/css/user_center.css"></style>
<style>
.pad-btm-80 {
  padding-bottom: 100px;
}

.person-input-item .el-cascader {
  border: none;
}

.person-input-item input {
  height: 34px;
  padding: 0 10px;
  border: 1px solid #F4F4F4;
  border-radius: 8px;
  color: #000000;
}
</style>
